stimulusApp.register(
  "search--idea",
  class extends Stimulus.Controller {
    static targets = ["ideasList", "locationsList", "locations", "hero"]
    static outlets = ["search--location-form"]
    static values = {
      ideaCount: Number,
    }

    #activeIdeaId = null
    #ideaSessionId = null
    #onAppMessage = null

    connect() {
      this.#onAppMessage = this.#handleAppMessage.bind(this)
      window.addEventListener("message", this.#onAppMessage)
    }

    disconnect() {
      window.removeEventListener("message", this.#onAppMessage)
      this.#onAppMessage = null
    }

    showLocations(event) {
      const searchIdeaId = String(event.params.searchIdeaId)
      this.#showIdeasList(false)
      this.#revealOnlyMatching(this.locationsTargets, searchIdeaId)
      this.#revealOnlyMatching(this.heroTargets, searchIdeaId)
      this.#notifyIdeaLocationsActive(true)
      this.#activeIdeaId = searchIdeaId
      this.#ideaSessionId = HB.uuidv4()
      const card = event.currentTarget
      const siblings = card?.parentNode
        ? Array.from(card.parentNode.children)
        : []
      const position = siblings.indexOf(card)
      Activity.capture("search-ideas idea opened", {
        idea_id: searchIdeaId,
        position,
        surface: "mobile-overlay",
        trigger: "click",
        idea_session_id: this.#ideaSessionId,
      })
      HB.postMessageForVersion({ action: "search_idea_location" }, "2.5.5")
    }

    backToIdeas() {
      const closingIdeaId = this.#activeIdeaId
      const closingSessionId = this.#ideaSessionId
      this.#showIdeasList(true)
      this.#hideAll(this.heroTargets)
      this.#notifyIdeaLocationsActive(false)
      if (closingIdeaId) {
        Activity.capture("search-ideas idea closed", {
          idea_id: closingIdeaId,
          surface: "mobile-overlay",
          idea_session_id: closingSessionId,
          reason: "back_button",
        })
      }
      this.#notifyLocationStopped()
      this.#activeIdeaId = null
      this.#ideaSessionId = null
    }

    reset() {
      this.#showIdeasList(true)
      this.#hideAll(this.locationsTargets)
      this.#hideAll(this.heroTargets)
      this.#notifyLocationStopped()
      this.#activeIdeaId = null
      this.#ideaSessionId = null
    }

    notifyDestinationSelected() {
      this.#notifyLocationStopped()
      this.#activeIdeaId = null
      this.#ideaSessionId = null
    }

    onLocationsLoaded() {
      if (this.#activeIdeaId) {
        this.#revealOnlyMatching(this.locationsTargets, this.#activeIdeaId)
      }
    }

    // Exposed for the location-form controller to attribute clicks back to the
    // currently-open idea on mobile (via the search--idea outlet).
    currentIdeaSession() {
      if (!this.#activeIdeaId) return null
      return { ideaId: this.#activeIdeaId, sessionId: this.#ideaSessionId }
    }

    #showIdeasList(visible) {
      this.ideasListTarget.classList.toggle("hidden", !visible)
      this.locationsListTarget.classList.toggle("hidden", visible)
    }

    #revealOnlyMatching(targets, searchIdeaId) {
      targets.forEach((el) => {
        el.classList.toggle("hidden", el.dataset.searchIdeaId !== searchIdeaId)
      })
    }

    #hideAll(targets) {
      targets.forEach((el) => el.classList.add("hidden"))
    }

    #notifyIdeaLocationsActive(active) {
      if (this.hasSearchLocationFormOutlet) {
        this.searchLocationFormOutlet.setIdeaLocationsActive(active)
      }
    }

    #notifyLocationStopped() {
      if (!this.#activeIdeaId) return
      HB.postMessageForVersion({ action: "search_idea_location_stop" }, "2.5.5")
    }

    #handleAppMessage(event) {
      let data
      try {
        data = JSON.parse(event.data)
      } catch (e) {
        return
      }
      if (data?.action === "search_ideas_back_clicked" && this.#activeIdeaId) {
        this.backToIdeas()
      }
    }
  },
)
